module.exports = __webpack_public_path__ + "static/media/Sharp-LS013B7DH03-Mechanical-Drawing.87ab715f.png";